module.exports = __webpack_public_path__ + "static/media/legen_40ltr_simo.e25be884.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sales/legen_40ltr_simo.jpg
// module id = 236
// module chunks = 0